import api from '@/libs/axios'

export default {
  getFeedbacks: () => api.get('/feedback'),
  createFeedback: feedback => api.post('/feedback', feedback),
  getFeedbackById: id => api.get(`/feedback/get/${id}`),
  getFeedbackDashboardMaster: () => api.get('/feedback/dashboard'),
}
